import React from "react";

export function ListPlusIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33325 8.00004C1.33325 7.63185 1.63173 7.33337 1.99992 7.33337H7.33325C7.70144 7.33337 7.99992 7.63185 7.99992 8.00004C7.99992 8.36823 7.70144 8.66671 7.33325 8.66671H1.99992C1.63173 8.66671 1.33325 8.36823 1.33325 8.00004Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33325 4.00004C1.33325 3.63185 1.63173 3.33337 1.99992 3.33337H10.6666C11.0348 3.33337 11.3333 3.63185 11.3333 4.00004C11.3333 4.36823 11.0348 4.66671 10.6666 4.66671H1.99992C1.63173 4.66671 1.33325 4.36823 1.33325 4.00004Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33325 12C1.33325 11.6319 1.63173 11.3334 1.99992 11.3334H10.6666C11.0348 11.3334 11.3333 11.6319 11.3333 12C11.3333 12.3682 11.0348 12.6667 10.6666 12.6667H1.99992C1.63173 12.6667 1.33325 12.3682 1.33325 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9999 5.33337C12.3681 5.33337 12.6666 5.63185 12.6666 6.00004V10C12.6666 10.3682 12.3681 10.6667 11.9999 10.6667C11.6317 10.6667 11.3333 10.3682 11.3333 10V6.00004C11.3333 5.63185 11.6317 5.33337 11.9999 5.33337Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33325 8.00004C9.33325 7.63185 9.63173 7.33337 9.99992 7.33337H13.9999C14.3681 7.33337 14.6666 7.63185 14.6666 8.00004C14.6666 8.36823 14.3681 8.66671 13.9999 8.66671H9.99992C9.63173 8.66671 9.33325 8.36823 9.33325 8.00004Z"
        fill="currentColor"
      />
    </svg>
  );
}
